import React, { Component } from 'react';
import LayoutPages from '../../Components/LayoutPages';
import {
    Form,
    Input,
    Divider,
    Select,
    Row,
    Col,
    InputNumber,
    DatePicker,
    Button,
    Table
} from 'antd';

import './NotificarClientes.css';

const FormItem = Form.Item;
const Option = Select.Option;
const { RangePicker } = DatePicker;
const { TextArea } = Input;

const columns = [{
    title: 'Nome',
    dataIndex: 'nome',
    key: 'nome',
}, {
    title: 'Telefone',
    dataIndex: 'telefone',
    key: 'telefone',
}];

const data = [];

for (var i = 0; i < 30; i++) {
    data.push({
        key: i,
        nome: 'John Brown ' + i,
        telefone: `(11) 234${i}-9823`
    })
}

class NotificarClientes extends Component {

    handleSubmit = (e) => {
        e.preventDefault();
    }

    render() {

        const { getFieldDecorator } = this.props.form;

        return (
            <LayoutPages pageTitle="Notificar Clientes" pageLocation={this.props.location} history={this.props.history} pageIndex="8">

                <Row gutter={8}>
                    <Col lg={{ span: 12, offset: 6 }} md={{ span: 12, offset: 6 }} sm={{ span: 24 }}>

                        <Form onSubmit={this.handleSubmit}>

                            <FormItem
                                label="Mensagem">
                                {getFieldDecorator('mensagem', {
                                    rules: [{
                                        required: true, message: 'Insira a mensagem',
                                    }],
                                })(
                                    <TextArea autosize={{ minRows: 3, maxRows: 6 }} />
                                )}
                            </FormItem>

                            <Divider orientation="left">Filtros</Divider>

                            <Row gutter={8}>
                                <Col lg={{ span: 12 }} md={{ span: 12 }} sm={{ span: 24 }}>
                                    <FormItem
                                        label="Enviar notificações para clientes">
                                        {getFieldDecorator('enviar_para', {
                                            initialValue: "1",
                                            rules: [{
                                                required: true, message: 'Selecione uma opção',
                                            }],
                                        })(
                                            <Select>
                                                <Option value="1">Com nenhuma corrida no periodo abaixo.</Option>
                                                <Option value="2">Com até</Option>
                                                <Option value="3">a partir de</Option>
                                            </Select>
                                        )}
                                    </FormItem>
                                </Col>

                                <div className={(this.props.form.getFieldValue('enviar_para') != "1") ? "" : "displayNone"}>
                                    <Col lg={{ span: 12 }} md={{ span: 12 }} sm={{ span: 24 }}>
                                        <FormItem
                                            label=""
                                            className="mrgTopField">
                                            {getFieldDecorator('numero_corridas', {
                                                initialValue: "0",
                                                rules: [{
                                                    required: false
                                                }],
                                            })(
                                                <InputNumber min={0} style={{ marginRight: '10px' }} />
                                            )}
                                            corridas no periodo abaixo.
                                        </FormItem>
                                    </Col>
                                </div>

                            </Row>

                            <FormItem
                                label="Período">
                                {getFieldDecorator('periodo', {
                                    initialValue: "1",
                                    rules: [{
                                        required: false, message: 'Selecione o filtro',
                                    }],
                                })(
                                    <Select>
                                        <Option value="1">Hoje</Option>
                                        <Option value="2">Ontem</Option>
                                        <Option value="3">Últimos 7 dias</Option>
                                        <Option value="4">Últimos 15 dias</Option>
                                        <Option value="5">Últimos 30 dias</Option>
                                        <Option value="6">Esta semana</Option>
                                        <Option value="7">Semana passada</Option>
                                        <Option value="8">Este mês</Option>
                                        <Option value="9">Mês passado</Option>
                                        <Option value="0">Personalizado</Option>
                                    </Select>
                                )}
                            </FormItem>

                            <div className={(this.props.form.getFieldValue('periodo') == "0") ? "" : "displayNone"}>
                                <FormItem
                                    label="Data personalizada">
                                    {getFieldDecorator('data', {
                                        rules: [{
                                            required: true, message: 'Insira a data',
                                        }],
                                    })(
                                        <RangePicker
                                            format="DD/MM/YYYY"
                                            placeholder={['Data inicial', 'Data final']}
                                        />
                                    )}
                                </FormItem>
                            </div>

                            <FormItem>
                                <Button type="primary" className="login-form-button">Filtrar</Button>
                            </FormItem>

                            <Row gutter={8}>
                                <Col span={24}>
                                    <p>Encontramos <strong>2350</strong> clientes que correspondem aos parametros acima</p>
                                </Col>
                            </Row>

                            <Table columns={columns} dataSource={data} bordered />

                            <Row gutter={8}>
                                <Col span={12}>
                                    <FormItem>
                                        <Button type="danger" className="login-form-button">Cancelar</Button>
                                    </FormItem>
                                </Col>
                                <Col span={12}>
                                    <FormItem>
                                        <Button type="primary" className="login-form-button">Enviar</Button>
                                    </FormItem>
                                </Col>
                            </Row>

                        </Form>
                    </Col>
                </Row>
            </LayoutPages>
        )
    }
}
export default Form.create()(NotificarClientes);


// WEBPACK FOOTER //
// ./src/Pages/NotificarClientes/NotificarClientes.js